<!-- TODO: out of use. consider to remove some info from ADD_RECEIPT -->
<template>
  <div>
    <div class="modal fade" data-backdrop="static" id="modal-receipt-customer">
      <div class="modal-dialog custom_modal">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title">{{$t('receipt.receipt_customer.title_receipt_customer')}}</h1>
          </div>
          <div class="modal-body">
            <b-form>
              <div class="row">
                <div class="box box-info" style="border:0px solid red;">
                  <div class="info-box">
                    <span class="info-box-icon bg-aqua">
                      <i class="fa fa-usd"></i>
                    </span>

                    <div class="row" style="margin-bottom: 10px;border:0px solid red;">
                      <div class="col-sm-2 col-md-2 col-lg-2" style="margin-top:10px;">
                        <div
                          class="info-box-content"
                          style="border-right:1px solid gray;margin-left:-16px;"
                        >
                          <span class="info-box-text">Số Tiền Ví Hiện Tại:</span>
                          <span class="info-box-number">
                            <font
                              color="black"
                            >{{customer_receipt.summary.summary_rest_of_money_momo_format}} VNĐ</font>
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2" style="margin-top:10px;">
                        <div
                          class="info-box-content"
                          style="border-right:1px solid gray;margin-left:-30px;"
                        >
                          <span class="info-box-text">Thanh Toán:</span>
                          <span class="info-box-number">
                            <font
                              color="black"
                            >{{customer_receipt.summary.summary_receipt_money}} VNĐ</font>
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2" style="margin-top:10px;">
                        <div
                          class="info-box-content"
                          style="border-right:1px solid gray;margin-left:-30px;"
                        >
                          <span class="info-box-text">Khách Đưa:</span>
                          <span class="info-box-number">
                            <font color="black">{{customer_receipt.number_of_money}} VNĐ</font>
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2" style="margin-top:10px;">
                        <div
                          class="info-box-content"
                          style="border-right:1px solid gray;margin-left:-30px;"
                        >
                          <span class="info-box-text">Tiền Thừa:</span>
                          <span class="info-box-number">
                            <font
                              color="black"
                            >{{customer_receipt.summary.summary_rest_of_money_format}} VNĐ</font>
                          </span>
                        </div>
                      </div>

                      <div class="col-sm-2 col-md-2 col-lg-2" style="margin-top:10px;">
                        <div
                          class="info-box-content"
                          style="border-right:0px solid gray;margin-left:-30px;"
                        >
                          <span class="info-box-text">Công Nợ:</span>
                          <span class="info-box-number">
                            <font color="red">{{customer_receipt.current_balance}} VNĐ</font>
                          </span>
                        </div>
                      </div>

                      <!-- <div class="col-sm-2 col-md-2 col-lg-2" style="margin-top:10px;">
                        <div
                          class="info-box-content"
                          style="border-right:1px solid gray;margin-left:-30px;"
                        >
                          <span class="info-box-text">Số Phải Thu:</span>
                          <span class="info-box-number">
                            <font
                              color="black"
                            >{{customer_receipt.summary.summary_paid_liabilit}} VNĐ</font>
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2" style="margin-top:10px;">
                        <div
                          class="info-box-content"
                          style="border-right:0px solid gray;margin-left:-30px;"
                        >
                          <span class="info-box-text">Số Chưa Thu:</span>
                          <span class="info-box-number">
                            <font
                              color="black"
                            >{{customer_receipt.summary.summary_unpaid_liabilit}} VNĐ</font>
                          </span>
                        </div>
                      </div>-->
                    </div>
                    <!-- /.info-box-content -->
                  </div>

                  <!-- /.info-box -->
                </div>
              </div>
              <!-- Row 1 -->
              <div class="row">
                <div class="col-sm-4 col-md-4 col-lg-4">
                  <!-- Customer name -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('receipt.receipt_customer.payment_method')"
                  >
                    <div class="form-group" style="display:-webkit-inline-box;">
                      <div>
                        <input
                          :disabled="customer_receipt.payments_type == 3"
                          type="radio"
                          name="some-radios"
                          id="cash"
                          value="1"
                          v-model="customer_receipt.payments_type"
                        />
                        <label for="cash">{{$t('payments.payments_type[0]')}}</label>
                      </div>
                      <div style="margin-left:20px;">
                        <input
                          :disabled="customer_receipt.payments_type == 3"
                          type="radio"
                          name="some-radios"
                          id="bank"
                          value="2"
                          v-model="customer_receipt.payments_type"
                        />
                        <label for="bank">{{$t('payments.payments_type[1]')}}</label>
                      </div>
                      <div style="margin-left:20px;">
                        <input
                          :disabled="customer_receipt.payments_type != 3"
                          type="radio"
                          name="some-radios"
                          id="bank"
                          value="3"
                          v-model="customer_receipt.payments_type"
                        />
                        <label for="bank">{{$t('payments.payments_type[2]')}}</label>
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <!-- Row 2 -->
              <div class="row">
                <div class="col-sm-4 col-md-4 col-lg-4">
                  <!-- Customer name -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('apartmentbookings.apartment_leaseback_clients.client')"
                  >
                    <div class="form-group">
                      <div>
                        <input
                          :placeholder="$t('apartmentbookings.apartment_leaseback_clients.client')"
                          class="form-control"
                          v-model="customer_receipt.customer_name"
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm-4 col-md-4 col-lg-4">
                  <!-- EMAIL -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('accounting_home_liability.apartment_code')"
                  >
                    <div class="form-group">
                      <div>
                        <input
                          :placeholder="$t('accounting_home_liability.apartment_code')"
                          class="form-control"
                          v-model="customer_receipt.apartment_code"
                          disabled
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm-4 col-md-4 col-lg-4">
                  <!-- EMAIL -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('receipt.receipt_customer.cashier')"
                  >
                    <div class="form-group">
                      <div>
                        <input
                          :placeholder="$t('receipt.receipt_customer.cashier')"
                          class="form-control"
                          v-model="customer_receipt.cashier"
                          disabled
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <!-- Row 3 -->
              <div class="row">
                <div class="col-sm-4 col-md-4 col-lg-4">
                  <!-- EMAIL -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('receipt.receipt_customer.date_of_export')"
                  >
                    <div class="form-group">
                      <div>
                        <date-picker
                          :placeholder="$t('receipt.receipt_customer.date_of_export')"
                          v-model="customer_receipt.date_of_export"
                          :config="options"
                          disabled
                        ></date-picker>
                      </div>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm-4 col-md-4 col-lg-4">
                  <!-- EMAIL -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('receipt.receipt_customer.document_date')"
                  >
                    <div class="form-group">
                      <div>
                        <date-picker
                          :placeholder="$t('receipt.receipt_customer.document_date')"
                          v-model="customer_receipt.document_date"
                          :config="options"
                        ></date-picker>
                      </div>
                    </div>
                  </b-form-group>
                </div>
                <div
                  class="col-sm-4 col-md-4 col-lg-4"
                  v-show="customer_receipt.use_amount_liablity > 0"
                >
                  <!-- EMAIL -->
                  <b-form-group label-size="sm" label-for="input-sm" label="Sử Dụng Dư Nợ">
                    <div class="form-group">
                      <div>
                        <input
                          :placeholder="$t('customer_receipt.use_amount_liablity_format')"
                          class="form-control"
                          v-model="customer_receipt.use_amount_liablity_format"
                          disabled
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <!-- Booking other details -->
              <b-form-group
                label-size="sm"
                label-for="input-sm"
                :label="$t('receipt.receipt_customer.receipt_reason')"
              >
                <div class="form-group">
                  <div>
                    <textarea
                      v-model="customer_receipt.receipt_reason"
                      :placeholder="$t('receipt.receipt_customer.receipt_reason')"
                      class="md-textarea form-control"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label-for="input-sm"
                :label="$t('receipt.receipt_customer.update_liability')"
              >
                <div class="form-group">
                  <b-table
                    :items="gridReceiptDataList"
                    :fields="gridColumns"
                    class="mt-3"
                    outlined
                    responsive
                    flex
                    striped
                    hover
                    style="border:1px solid #f4f4f4;margin-top:10px;"
                  >
                    <template #head()="scope">
                      <div>{{ $t(scope.label) }}</div>
                    </template>
                  </b-table>
                </div>
              </b-form-group>
            </b-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-success btn-sm pull-right"
              @click="updateReceipt"
            >{{$t('common.save')}}</button>
            <button
              v-show="false"
              type="button"
              style="margin-right:5px;"
              class="btn btn-warning btn-sm pull-right"
              @click="printReceipt"
            >{{$t('receipt.receipt_customer.button.receipt_printing')}}</button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeModal"
            >{{$t('common.back')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import utils from "@/lib/utils";
import Loading from "vue-loading-overlay";
export default {
  name: "lte-modal-einvoice",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isLoading: false,
      options: {
        format: "DD-MM-YYYY",
        useCurrent: false
      },
      customer_receipt: {
        payments_type: 1,
        customer_name: "",
        apartment_code: "",
        apartment_id: 0,
        amount: 0,
        receipt_reason: "",
        cashier: "",
        date_of_export: new Date(),
        document_date: new Date(),
        invoice_data: {},
        invoice_total_left_fees: {},
        current_balance: 0,
        number_of_money: 0,
        use_amount_liablity: 0,
        use_amount_liablity_format: 0,
        summary: {
          summary_rest_of_money_momo_format: 0,
          summary_rest_of_money_format: 0,
          summary_receipt_money: 0,
          summary_unpaid_liabilit: 0,
          summary_paid_liabilit: 0
        }
      },
      enter_the_liabilities: {
        explaination: null,
        number_of_money: 0
      },
      gridReceiptDataList: [],
      gridColumns: [
        {
          key: "receipt.receipt_customer.explanation",
          label: "receipt.receipt_customer.explanation",
          sortable: true,
          class: "text-center"
        },
        {
          key: "receipt.receipt_customer.number_of_money",
          label: "receipt.receipt_customer.number_of_money",
          sortable: true,
          class: "text-center"
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA"
      //"GET_THE_LATEST_RECEIPT_DATA"
    ])
  },
  methods: {
    closeModal: function() {
      $("#modal-receipt-customer").modal("hide");
      this.disabledCheckin = true;
    },

    loadCustomerReceipt: function(use_wallet) {
      if (use_wallet) {
        this.customer_receipt.payments_type = 3
      } else {
        this.customer_receipt.payments_type = 1
      }
      this.customer_receipt.customer_name = this.item.receipt_data.customer_name;
      this.customer_receipt.apartment_code = this.item.receipt_data.apartment_code;
      // this.customer_receipt.receipt_reason =
      //   "Thu tiền từ khách hàng " +
      //   this.customer_receipt.customer_name +
      //   " cho căn hộ " +
      //   this.customer_receipt.apartment_code;
      this.customer_receipt.receipt_reason =
        "Căn " +
        this.customer_receipt.apartment_code +
        " Thanh Toán Tiền Dịch Vụ";
      this.customer_receipt.apartment_id = parseInt(
        this.item.receipt_data.apartment_id
      );
      this.customer_receipt.cashier = this.item.receipt_data.cashier;
      this.gridReceiptDataList = this.item.liabilities;
      this.customer_receipt.amount = this.item.amount;
      this.customer_receipt.invoice_data = this.item.invoice_data;
      this.customer_receipt.invoice_total_left_fees = this.item.invoice_total_left_fees;
      this.customer_receipt.summary.summary_rest_of_money_momo_format =
        this.item.summary.summary_rest_of_money_momo_format !== undefined
          ? this.item.summary.summary_rest_of_money_momo_format : 0;
      this.customer_receipt.summary.summary_rest_of_money_format =
        this.item.summary.summary_rest_of_money_format !== undefined
          ? this.item.summary.summary_rest_of_money_format : 0;
      this.customer_receipt.summary.summary_receipt_money =
        this.item.summary.summary_receipt_money !== undefined
          ? this.item.summary.summary_receipt_money : 0;
      this.customer_receipt.summary.summary_unpaid_liabilit =
        this.item.summary.summary_unpaid_liabilit !== undefined
          ? this.item.summary.summary_unpaid_liabilit : 0;
      this.customer_receipt.summary.summary_paid_liabilit =
        this.item.summary.summary_paid_liabilit !== undefined
          ? this.item.summary.summary_paid_liabilit : 0;
      this.customer_receipt.current_balance = this.item.current_balance;
      this.customer_receipt.use_amount_liablity = utils.formatInteger(this.item.use_amount_liablity);
      if (this.customer_receipt.use_amount_liablity > 0) {
        this.customer_receipt.use_amount_liablity_format = utils.formatNumber(this.item.use_amount_liablity);
      }
      this.customer_receipt.number_of_money = this.item.number_of_money;
      $("#modal-receipt-customer").modal("show");
    },
    printReceipt: function() {},
    updateReceipt: async function() {
      $("#modal-receipt-customer").modal("hide");
      this.isLoading = true;
      let receipt_code = "";
      let data_home_ability = {
        invoices: this.item.invoice_data,
        is_momo_adjust_force: this.item.is_momo_adjust_force,
        date: utils.formatSqlDate(this.customer_receipt.date_of_export, "DD-MM-YYYY", "YYYY-MM-DDThh:mm"),
        explaination: this.customer_receipt.receipt_reason,
        apartment_code: this.customer_receipt.apartment_code
      };

      let data_left_fees = {
        total_left_fees: this.customer_receipt.invoice_total_left_fees
      };
      let data_explaination = [];
      this.item.liabilities.forEach(element => {
        let data_list = {
          explaination: element["receipt.receipt_customer.explanation"],
          amount: parseInt(
            utils.formatInteger(
              element["receipt.receipt_customer.number_of_money"]
            )
          )
        };
        data_explaination.push(data_list);
      });
      let amount = parseInt(
        utils.formatInteger(this.customer_receipt.summary.summary_receipt_money)
      );
      let data_receipt = {
        expected_amount: 0,
        actual_amount: 0,
        user_created: this.GET_ACCOUNT_DATA.id,
        receipt_type: parseInt(this.customer_receipt.payments_type),
        payer: this.customer_receipt.customer_name,
        apartment: this.customer_receipt.apartment_id,
        //amount: this.customer_receipt.amount,
        amount: amount,
        due_date: utils.formatSqlDate(this.customer_receipt.document_date, "DD-MM-YYYY", "YYYY-MM-DDThh:mm"),
        explaination: this.customer_receipt.receipt_reason
      };

      await this.ADD_RECEIPT(data_receipt).then(
        async function() {
          //$("#modal-receipt-customer").modal("hide");
          //this.SUCCESS_TOAST();
          await this.GET_THE_LATEST_RECEIPT().then(
            async function(res) {
              receipt_code = res.receipt_code;
              data_home_ability.invoices.forEach(v => {
                v.invoice_code = receipt_code;
              });
              await this.INSERT_ACCOUNTING_HOME_LIABILITY(data_home_ability).then(
                async function(res) {
                  //this.SUCCESS_TOAST();
                  if (parseInt(utils.formatInteger(this.customer_receipt.summary.summary_paid_liabilit)) > 0) {tProjectSession(),
                    await this.UPDATE_INVOICE_TOTAL_LEFT_FEES(data_left_fees)
                      .then(
                        async function(res) {
                          await this.ADD_RECEIPT_EXPLAINATION({
                            receiptCode: receipt_code,
                            receiptExplaination: data_explaination
                          }).then(
                            await function(res) {
                              $("#modal-receipt-customer").modal("hide");
                              this.SUCCESS_TOAST();
                              //location.reload();
                              this.isLoading = false;
                              this.$emit("reload_data", true);
                            }.bind(this)
                          )
                          .catch(
                            function(error) {
                              this.ON_SHOW_TOAST({
                                message: error,
                                styleType: "danger"
                              });
                              this.isLoading = false;
                            }.bind(this)
                          );
                        }.bind(this)
                      )
                      .catch(
                        function(error) {
                          this.ON_SHOW_TOAST({
                            message: error,
                            styleType: "danger"
                          });
                          this.isLoading = false;
                        }.bind(this)
                      );
                  } else {
                    await this.ADD_RECEIPT_EXPLAINATION({
                      receiptCode: receipt_code,
                      receiptExplaination: data_explaination
                    }).then(
                      function(res) {
                        this.$emit("reload_data");
                        $("#modal-receipt-customer").modal("hide");
                        this.SUCCESS_TOAST();
                        this.isLoading = false;
                      }.bind(this)
                    )
                    .catch(
                      function(error) {
                        this.ON_SHOW_TOAST({
                          message: error,
                          styleType: "danger"
                        });
                        this.isLoading = false;
                      }.bind(this)
                    );
                  }
                }.bind(this)
              )
              .catch(
                function(error) {
                  this.ON_SHOW_TOAST({
                    message: error,
                    styleType: "danger"
                  });
                  this.isLoading = false;
                }.bind(this)
              );
            }.bind(this)
          );
        }.bind(this)
      )
      .catch(
        function() {
          this.ERROR_TOAST();
          this.isLoading = false;
        }.bind(this)
      );
    },
    ...mapActions("accountingHomeLiabilityModule", [
      "INSERT_ACCOUNTING_HOME_LIABILITY"
    ]),
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "ADD_RECEIPT",
      "UPDATE_INVOICE_TOTAL_LEFT_FEES",
      "ADD_RECEIPT_EXPLAINATION",
      "GET_THE_LATEST_RECEIPT"
      //"INSERT_ACCOUNTING_HOME_LIABILITY"
    ])
  },
  mounted() {},
  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker,
    loading: Loading
  }
};
</script>
<style lang="scss" scoped>
.mg-left {
  margin-left: 5px;
}
.hide-scroll-bar::-webkit-scrollbar {
  display: none;
}
.custom_modal {
  width: 95% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Receipt/ComponentReceiptCustomer.vue